export function header() {

    const path = location.pathname;

    const header = document.querySelector('.j-header');
    const header_btn = document.querySelector('.j-header_btn');
    const header_links = document.querySelectorAll('.j-header_link');

    header_btn.addEventListener('click', () => {
        if (header.classList.contains('active')) {
            header.classList.remove('active');
        } else {
            header.classList.add('active');
        }
    });

    if (window.matchMedia("(max-width: 768px)").matches) {
        [...header_links].forEach((link) => {
            link.addEventListener('click', () => {
                if (header.classList.contains('active')) {
                    header.classList.remove('active');
                    header_loop.classList.remove('active');
                } else {
                    header.classList.add('active');
                    header_loop.classList.add('active');
                }
            });
        });

        const toggle = document.querySelector('.j-header_ac-toggle');
        const content = document.querySelector('.j-header_ac-cont');

        if (!toggle || !content) return;

        toggle.addEventListener('click', () => {
            const isOpen = content.classList.contains('is-open');

            if (isOpen) {
            content.style.maxHeight = '0px';
            content.classList.remove('is-open');
            } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('is-open');
            }
        });
    }

    //スクロールで非表示
    const hH = header.clientHeight;
    const winH = window.innerHeight;
    const docH = document.documentElement.scrollHeight;
    const windBtm = docH - winH;
    // 現在地を示す変数を定義
    let pos = 0;
    // スクロール直前の位置を示す変数を定義
    let lastPos = 0;

    // const onScroll = () => {
    //     if (pos > hH && pos > lastPos) {
    //         header.classList.add("header--unpinned");
    //     }
    //     // スクロール位置がヘッダーの高さ分より小さいか
    //     // またはスクロール位置が最後のスクロール位置より小さい場合はclass名を削除
    //     if (pos < hH || pos < lastPos || windBtm <= pos) {
    //         header.classList.remove("header--unpinned");
    //     }

    //     // 最後のスクロール位置を保存
    //     lastPos = pos;
    // };

    // window.addEventListener("scroll", () => {
    //     // スクロールするごとにpos（現在地）の値を更新
    //     pos = window.scrollY;
    //     onScroll();
    // });


    // const header = document.querySelector('.j-header');
    const target = document.querySelector('.p-home_fv');

    if (header) {
    let lastScroll = window.scrollY;

    // ファーストビュー通過判定
    if (target) {
        const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
            header.classList.add('is-under');
            } else {
            header.classList.remove('is-under');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: `-${header.offsetHeight}px 0px 0px 0px`
        }
        );

        observer.observe(target);
    }
    }

}